export const getPercentageStyles = (percentage: number) => {
  if (percentage >= 85) {
    return {
      color: "#1F7A1F",
      background: "#E7F6EC",
    };
  }
  if (percentage >= 70) {
    return {
      color: "#9A6700",
      background: "#FFF4D6",
    };
  }
  return {
    color: "#B42318",
    background: "#FEE4E2",
  };
};

export interface StudentAttendanceRowData {
  id: string;
  name: string;
  status: string;
}

export const STATUS_STYLES: Record<
  string,
  {
    rowBg: string;
    badgeBg: string;
    badgeText: string;
  }
> = {
  present: {
    rowBg: "#ECFDF5",
    badgeBg: "#10B981",
    badgeText: "#FFFFFF",
  },
  absent: {
    rowBg: "#FEF2F2",
    badgeBg: "#EF4444",
    badgeText: "#FFFFFF",
  },
};

export const getLast7DaysRange = (batchEndDate?: Date | string | null) => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  yesterday.setHours(0, 0, 0, 0);

  const parsedBatchEnd = batchEndDate ? new Date(batchEndDate) : null;
  const hasValidBatchEnd =
    parsedBatchEnd instanceof Date && !isNaN(parsedBatchEnd.getTime());

  const end =
    hasValidBatchEnd && parsedBatchEnd < today ? parsedBatchEnd : yesterday;
  end.setHours(0, 0, 0, 0);

  const start = new Date(end);
  start.setDate(end.getDate() - 6);

  return {
    startDate: formatDate(start),
    endDate: formatDate(end),
  };
};

export const formatDate = (input?: Date | string | null) => {
  if (!input) return "";
  const date = input instanceof Date ? input : new Date(input);
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const getYesterday = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  d.setHours(0, 0, 0, 0); // normalize (optional but safer)
  return d;
};

export const normalizeToDate = (value: Date | string | null): Date => {
  if (!value) return new Date();
  return typeof value === "string" ? new Date(value) : new Date(value);
};

export const buildStartOfDay = (base: Date) => {
  const d = new Date(base);
  return d;
};

export const buildEndFromStart = (start: Date) => {
  const d = new Date(start);
  d.setHours(d.getHours() + 1);
  return d;
};

export const getSafeDateValue = (
  value: Date | string | null | undefined,
): Date | null => {
  if (!value) return null;

  const date = value instanceof Date ? value : new Date(value);

  return isNaN(date.getTime()) ? null : date;
};

export const formatTimeOnly = (value?: string | Date) => {
  if (!value) return "--:--";

  const date = value instanceof Date ? value : new Date(value);

  if (isNaN(date.getTime())) return "--:--";

  return date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
  });
};
